import "./index.css";
import { Composition } from "remotion";
import { HelloWorld, myCompSchema } from "./HelloWorld";
import { Logo, myCompSchema2 } from "./HelloWorld/Logo";
import { TauchforschungVideo, tauchforschungSchema } from "./TauchforschungVideo";

import { TalkVideo, calcTalkvideoMetadata, talkvideoSchema } from "./TalkVideo";
import { TestCroppedImage } from "./test/TestCroppedImage";


// Each <Composition> is an entry in the sidebar!

export const RemotionRoot: React.FC = () => {
  const queryParams =
    typeof window === 'undefined' ? null : new URLSearchParams(window.location.search);
  const urlDocumentSlug = queryParams?.get('slug');
  const urlDocumentUrl = queryParams?.get('docUrl');
  const urlLegacyVideoMdFile = queryParams?.get('videoMdFile');

  return (
    <>

      <Composition
        id="WerkzeughEvent"
        component={TalkVideo}
        durationInFrames={800}
        fps={30}
        width={1080}
        height={1920}
        schema={talkvideoSchema}
        defaultProps={{
          videoMdFile: urlLegacyVideoMdFile ?? "current",
          documentSlug: urlDocumentSlug ?? undefined,
          documentUrl: urlDocumentUrl ?? undefined,
          data: null,
          primaryColor: "#4A90E2",
          secondaryColor: "#7DD3FC",
          accentColor: "#F97316",
          logoName: "talk_logo2.svg",
          transitionType: "fade"
        }}
        calculateMetadata={calcTalkvideoMetadata}
      />
      <Composition
        // You can take the "id" to render a video:
        // npx remotion render HelloWorld
        id="HelloWorld"
        component={HelloWorld}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        // You can override these props for each render:
        // https://www.remotion.dev/docs/parametrized-rendering
        schema={myCompSchema}
        defaultProps={{
          titleText: "Welcome to Remotion",
          titleColor: "#000000",
          logoColor1: "#91EAE4",
          logoColor2: "#86A8E7",
        }}
      />

      {/* Mount any React component to make it show up in the sidebar and work on it individually! */}
      <Composition
        id="OnlyLogo"
        component={Logo}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        schema={myCompSchema2}
        defaultProps={{
          logoColor1: "#91dAE2" as const,
          logoColor2: "#86A8E7" as const,
        }}
      />

      {/* Tauchforschung Hirlatz Marketing Video - Instagram Reel Format */}
      <Composition
        id="TauchforschungReel"
        component={TauchforschungVideo}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
        schema={tauchforschungSchema}
        defaultProps={{
          primaryColor: "#4A90E2",
          secondaryColor: "#7DD3FC",
          accentColor: "#F97316",
        }}
        calculateMetadata={calcTalkvideoMetadata}
      />

      {/* Talk Video - Instagram Reel Format */}
      <Composition
        id="TalkReelWetti"
        component={TalkVideo}
        durationInFrames={500}
        fps={30}
        width={1080}
        height={1920}
        schema={talkvideoSchema}
        defaultProps={{
          primaryColor: "#4A90E2",
          secondaryColor: "#7DD3FC",
          accentColor: "#F97316",
          data: null,
          logoName: "talk_logo2.svg",
          transitionType: "slide"
        }}
        calculateMetadata={calcTalkvideoMetadata}
      />
      <Composition
        id="TalkReelBarbaraUngepflegt"
        component={TalkVideo}
        durationInFrames={800}
        fps={30}
        width={1080}
        height={1920}
        schema={talkvideoSchema}
        defaultProps={{
          videoMdFile: "video1",
          data: null,
          primaryColor: "#4A90E2",
          secondaryColor: "#7DD3FC",
          accentColor: "#F97316",
          logoName: "talk_logo2.svg",
          transitionType: "fade"
        }}
        calculateMetadata={calcTalkvideoMetadata}
      />



      <Composition
        id="TalkReelPilz"
        component={TalkVideo}
        durationInFrames={500}
        fps={30}
        width={1080}
        height={1920}
        schema={talkvideoSchema}
        defaultProps={{
          videoMdFile: "video2",
          data: null,
          primaryColor: "#4A90E2",
          secondaryColor: "#7DD3FC",
          accentColor: "#F97316",
          logoName: "talk_logo2.svg",
          transitionType: "fade"
        }}
        calculateMetadata={calcTalkvideoMetadata}
      />
      <Composition
        id="TalkReelGarden"
        component={TalkVideo}
        durationInFrames={500}
        fps={30}
        width={1080}
        height={1920}
        schema={talkvideoSchema}
        defaultProps={{
          data: null,
          primaryColor: "#4A90E2",
          secondaryColor: "#7DD3FC",
          accentColor: "#F97316",
          logoName: "werkzeugH_logo_h.svg",
          transitionType: "slide"
        }}
        calculateMetadata={calcTalkvideoMetadata}
      />
      <Composition
        id="TestCroppedImage"
        component={TestCroppedImage}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
    </>
  );
};

;
    var _remotion_globalVariableA, _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
